(function () {
  var legacyArticleRedirects = {
    '/blogs/hosting-journal/marble-brass-living-room': '/blogs/hosting-journal/marble-brass-modern-living-room-hosting',
    '/blogs/hosting-journal/elevated-home-viewing-party-checklist': '/blogs/hosting-journal/elevated-home-viewing-party-checklist-tatpub',
    '/blogs/hosting-journal/luxury-bar-cart-date-night-private-evening-at-home': '/blogs/hosting-journal/private-evening-luxury-bar-cart-at-home',
    '/blogs/hosting-journal/sustainable-luxury-furniture-tatpub-marble-bar-cart-guide': '/blogs/hosting-journal/sustainable-luxury-furniture-home-hosting-guide'
  };
  if (legacyArticleRedirects[window.location.pathname]) {
    window.location.replace(legacyArticleRedirects[window.location.pathname]);
    return;
  }

  var safeDescription = 'Architectural hosting objects for considered homes.';
  var oldEvent = ['World', 'Cup'].join(' ');
  var oldHandle = ['tatpub', 'world', 'cup', 'hosting', 'system', 'bar', 'cart'].join('-');
  var newProductPath = '/products/tatpub-hosting-system-edition-01';

  var replacements = [
    [new RegExp('TATPUB ' + oldEvent + ' Hosting System Bar Cart', 'g'), 'TATPUB Hosting System - Edition 01'],
    [new RegExp(oldEvent + ' Hosting System', 'g'), 'Architectural Hosting System'],
    [new RegExp(oldEvent + ' gatherings', 'g'), 'match-night gatherings'],
    [new RegExp('/products/' + oldHandle, 'g'), newProductPath],
    [/Add to Cart/g, 'Add to Bag'],
    [/ADD TO CART/g, 'ADD TO BAG'],
    [/Add to cart/g, 'Add to Bag'],
    [/Item added to your cart/g, 'Added to Your Bag'],
    [/View cart/g, 'View Bag'],
    [new RegExp(['Free', ['white', 'glove'].join('-'), 'delivery'].join(' '), 'g'), 'Delivery details through Client Care'],
    [new RegExp([['30', 'day'].join('-'), 'returns'].join(' '), 'g'), 'Review return policy'],
    [/Welcome to our store/g, safeDescription],
    [new RegExp([['Ital', 'ian'].join(''), 'Carrara', 'marble'].join(' '), 'g'), 'Natural marble'],
    [new RegExp([['hand', 'forged'].join('-'), 'hammered', 'brass'].join(' '), 'g'), 'hammered brass'],
    [new RegExp([['hand', 'forged'].join('-'), 'brass'].join(' '), 'g'), 'hammered brass'],
    [new RegExp([['F', 'SC'].join(''), 'teak'].join(' '), 'g'), 'teak-inspired warmth'],
    [/Sustainable Luxury CMF/g, 'Material-Led Luxury CMF']
  ];

  function replaceValue(value) {
    if (!value) return value;
    return replacements.reduce(function (next, pair) {
      return next.replace(pair[0], pair[1]);
    }, value);
  }

  function patchTextNodes(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var next = replaceValue(node.nodeValue);
      if (next !== node.nodeValue) node.nodeValue = next;
    }
  }

  function patchAttributes(root) {
    root.querySelectorAll('a[href], img[alt], [aria-label], meta[content]').forEach(function (element) {
      ['href', 'alt', 'aria-label', 'content'].forEach(function (attr) {
        if (!element.hasAttribute(attr)) return;
        var current = element.getAttribute(attr);
        var next = replaceValue(current);
        if (next !== current) element.setAttribute(attr, next);
      });
    });
  }

  function setLink(link, label, href) {
    if (!link) return;
    link.textContent = label;
    link.setAttribute('href', href);
    link.setAttribute('aria-label', label);
  }

  function ensureNavLink(parent, label, href) {
    if (!parent || parent.querySelector('a[href="' + href + '"]')) return;
    var sample = parent.querySelector('a');
    if (!sample) return;
    var link = sample.cloneNode(true);
    setLink(link, label, href);
    parent.appendChild(link);
  }

  function patchNavigation() {
    var home = document.querySelector('a[href="/"], a[href="https://tatpub.com/"]');
    var navParent = home && home.parentElement;
    var catalog = document.querySelector('a[href="/collections/all"], a[href$="/collections/all"]');
    var contact = document.querySelector('a[href="/pages/contact"], a[href$="/pages/contact"]');
    var login = document.querySelector('a[href*="customer_authentication"], a[href*="/account"]');
    var cart = document.querySelector('a[href="/cart"], a[href$="/cart"]');

    setLink(catalog, 'Edition 01', newProductPath);
    setLink(contact, 'Design Consultation', '/pages/design-consultation');
    if (login) login.textContent = 'Client Account';
    if (cart) cart.textContent = 'Bag';

    ensureNavLink(navParent, 'Rituals', '/pages/match-night-hosting');
    ensureNavLink(navParent, 'Craft', '/pages/craft');
    ensureNavLink(navParent, 'Journal', '/blogs/hosting-journal');
    ensureNavLink(navParent, 'Trade', '/pages/trade-hospitality');
    ensureNavLink(navParent, 'Client Care', '/pages/client-care');
  }

  function patchMeta() {
    document.querySelectorAll('meta[name="description"], meta[property="og:description"], meta[name="twitter:description"]').forEach(function (meta) {
      var content = meta.getAttribute('content') || '';
      if (content.indexOf(oldEvent) !== -1 || content.indexOf(['FI', 'FA'].join('')) !== -1) {
        meta.setAttribute('content', safeDescription);
      }
    });
  }

  function patchHomepageLinks() {
    document.querySelectorAll('a[href*="' + oldHandle + '"]').forEach(function (link) {
      link.href = link.href.replace(oldHandle, 'tatpub-hosting-system-edition-01');
    });
  }

  function patchSupportExperience() {
    var roomFitReplacement =
      'To share room photos, email them to <a href="mailto:support@tatpub.com?subject=Room%20Fit%20Review%20Request%20-%20TATPUB">support@tatpub.com</a> after submitting the consultation request with the subject "Room Fit Review".';

    document.querySelectorAll('.shopify-section-group-header-group [data-tatpub-global-footer], .shopify-section-group-header-group .tatpub-footer').forEach(function (footer) {
      footer.remove();
    });

    document.querySelectorAll('[data-tatpub-global-footer]').forEach(function (footer) {
      if (!footer.closest('.shopify-section-group-footer-group')) footer.remove();
    });

    document.querySelectorAll('p, li, div').forEach(function (node) {
      if (node.children.length > 2) return;
      if (node.textContent.indexOf('OWNER_INPUT_REQUIRED: branded support email needed') !== -1) {
        node.innerHTML = roomFitReplacement;
      }
    });

    if (window.location.pathname === '/cart' && !document.querySelector('[data-tatpub-support-line]')) {
      var cartTarget = document.querySelector('.cart__footer') || document.querySelector('main');
      if (cartTarget) {
        var cartLine = document.createElement('p');
        cartLine.className = 'tatpub-client-care-support-line';
        cartLine.setAttribute('data-tatpub-support-line', '');
        cartLine.innerHTML =
          'Questions before checkout? Contact Client Care at <a href="mailto:support@tatpub.com?subject=Checkout%20Question%20-%20TATPUB">support@tatpub.com</a>.';
        cartTarget.appendChild(cartLine);
      }
    }
  }

  function run() {
    patchMeta();
    patchTextNodes(document.body);
    patchAttributes(document);
    patchNavigation();
    patchHomepageLinks();
    patchSupportExperience();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('load', run);
  setTimeout(run, 250);
  setTimeout(run, 1000);
  setTimeout(run, 2200);
  setTimeout(run, 4200);
})();
